import useApiQuery from 'shared/hooks/use-api-query';
import {UserProps} from 'modules/users/types';

const useDeliveryMenSelect = (orderId: string, enabled = false) => {
  const {data = [], ...rest} = useApiQuery<UserProps[]>({
    url: `/orders/${orderId}/delivery-men/all`,
    enabled,
  });

  return {
    ...rest,
    data: data?.map((user) => ({
      label: user.name,
      value: user.id,
    })),
  };
};

export default useDeliveryMenSelect;
